enum SelfEnrolmentStatus {
	Disabled = "disabled",
	Enabled = "enabled",
	RequiresApproval = "requires_approval",
}

export default SelfEnrolmentStatus;
